//Dependencies
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//Main Components
import Drawer from '../../../components/Drawer';
//Components

const Drawer03 = (props) =>
{
  const { isMobile } = props; 
  const dispatch = useDispatch();

  const drawer03 = useSelector(state => state.drawers.drawer03);
  const portfolio = useSelector(state => state.portfolio.portfolio);

  const closeDrawer = () =>
  {
    const scroller = document.querySelector("#scroller");
    scroller.scrollTo(0,0);

    dispatch({type: 'SET_DRAWER_03', drawer03 : false});
  };

  return(
    <Drawer
      height    = {isMobile ? 80 : 80}
      visible   = {drawer03}
      onClose   = {() => closeDrawer()}      
    >
      <div className = "w-full bg-white select-none">
        <div className = "flex bg-white  mt-10">
          <div className = "w-full justify-center flex">
            <div className = "px-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-1">
              {portfolio}
            </div>
          </div>
        </div>

        <div className = "flex justify-center bg-white"  >
          <button
              className = 'bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 border border-red-700 rounded lg:w-1/4 w-2/3 text-lg tracking-widest mb-2 mt-5'
              onClick={() => 
                {
                  closeDrawer();
                }}
            >
              CERRAR
            </button>
        </div>
      </div>
    </Drawer>
  );
}

export default Drawer03;